import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Package, ShoppingCart, Sparkles, MessageSquare, AlertTriangle, ArrowRight } from "lucide-react";
import { api, formatTL } from "@/lib/api";

const STATUS_LABELS = { yeni: "Yeni", hazirlaniyor: "Hazırlanıyor", kargoda: "Kargoda", tamamlandi: "Tamamlandı", iptal: "İptal" };

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/admin/stats").then((r) => setStats(r.data)); }, []);

  if (!stats) return <div className="text-larc-muted">Yükleniyor…</div>;

  return (
    <div data-testid="admin-dashboard">
      <div>
        <h1 className="font-heading text-4xl">Gösterge Paneli</h1>
        <p className="text-larc-muted mt-1">Atölyenin günlük özetine hoş geldiniz.</p>
      </div>

      <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <Stat icon={Package} label="Toplam Ürün" value={stats.total_products} testid="stat-products" />
        <Stat icon={ShoppingCart} label="Toplam Sipariş" value={stats.total_orders} testid="stat-orders" />
        <Stat icon={ShoppingCart} label="Bekleyen Sipariş" value={stats.pending_orders} testid="stat-pending" accent />
        <Stat icon={Sparkles} label="Özel Talepler" value={stats.custom_pending} testid="stat-custom" />
        <Stat icon={MessageSquare} label="Okunmamış Mesaj" value={stats.unread_messages} testid="stat-messages" />
        <Stat icon={AlertTriangle} label="Düşük Stok" value={stats.low_stock} testid="stat-low-stock" warn />
      </div>

      <div className="mt-10 bg-white border border-larc-border rounded-2xl">
        <div className="flex items-center justify-between p-6 border-b border-larc-border">
          <h2 className="font-heading text-2xl">Son Siparişler</h2>
          <Link to="/admin/orders" className="text-sm text-larc-muted hover:text-larc-gold inline-flex items-center gap-1.5">Tümü <ArrowRight size={14} /></Link>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-larc-alt text-larc-muted">
              <tr>
                <th className="text-left px-6 py-3">Sipariş No</th>
                <th className="text-left px-6 py-3">Müşteri</th>
                <th className="text-left px-6 py-3">Tutar</th>
                <th className="text-left px-6 py-3">Durum</th>
                <th className="text-left px-6 py-3">Tarih</th>
              </tr>
            </thead>
            <tbody>
              {stats.recent_orders.length === 0 ? (
                <tr><td colSpan="5" className="px-6 py-10 text-center text-larc-muted">Henüz sipariş yok</td></tr>
              ) : stats.recent_orders.map((o) => (
                <tr key={o.id} className="border-t border-larc-border">
                  <td className="px-6 py-3 font-medium">{o.order_number}</td>
                  <td className="px-6 py-3">{o.customer_name}</td>
                  <td className="px-6 py-3">{formatTL(o.total)}</td>
                  <td className="px-6 py-3"><StatusBadge status={o.status} /></td>
                  <td className="px-6 py-3 text-larc-muted">{new Date(o.created_at).toLocaleDateString("tr-TR")}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function Stat({ icon: Icon, label, value, testid, accent, warn }) {
  return (
    <div className="bg-white border border-larc-border rounded-xl p-6" data-testid={testid}>
      <div className="flex items-center justify-between">
        <span className="text-sm text-larc-muted">{label}</span>
        <span className={`inline-flex h-9 w-9 items-center justify-center rounded-full ${accent ? "bg-larc-gold/10 text-larc-gold" : warn ? "bg-orange-50 text-orange-600" : "bg-larc-alt text-larc-ink"}`}><Icon size={16} /></span>
      </div>
      <div className="font-heading text-4xl text-larc-ink mt-3">{value}</div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const colors = {
    yeni: "bg-blue-50 text-blue-700 border-blue-100",
    hazirlaniyor: "bg-amber-50 text-amber-700 border-amber-100",
    kargoda: "bg-purple-50 text-purple-700 border-purple-100",
    tamamlandi: "bg-green-50 text-green-700 border-green-100",
    iptal: "bg-red-50 text-red-700 border-red-100",
  };
  return <span className={`text-[10px] uppercase tracking-[0.15em] px-2.5 py-1 rounded-full border ${colors[status] || "bg-larc-alt text-larc-muted border-larc-border"}`}>{STATUS_LABELS[status] || status}</span>;
}
